export enum SentenceGenerateButtonStatus {
  active,
  inactive,
  onLoading,
}
